<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    :class="
      cn(
        'p-5 rounded-2xl bg-background border border-surface-container-high shadow-md',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
